<template>
    <div id="imageMessage" class="" @mouseenter="hovered = true" @mouseleave="hovered = false">
        <viewer :id="'imageViewer-' + message.raw.asset._id" :images="[imageSrc()]" ref="imageViewer">
            <div class="cb-img-preview" @click="show">
                <img
                    :id="'img-' + message.raw.asset._id"
                    :src="imageSrc()"
                    class="img-thumbnail ant-upload-list-picture-card-container"
                    style="object-fit: cover"
                />
                <md-icon v-if="hovered" class="cb-pr-icon" @click="show"> visibility</md-icon>
            </div>
        </viewer>

        <span v-if="message.data.meta" class="sc-message--meta">{{ message.data.meta }}</span>
    </div>
</template>

<script>
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import Vue from "vue";
import { sendCommandToParentWindow } from "../../../../utils/parentWindowConnection";

Vue.use(Viewer);
export default {
    name: "ImageMessage",
    props: ["message"],
    data() {
        return {
            previewImg: false,
            hovered: false,
            fullscreenMode: false,
        };
    },
    methods: {
        show() {
            const id = "img-" + this.message.raw.asset._id;
            document.getElementById(id).click();
        },
        imageSrc() {
            const a = this.message.raw.asset;
            const isApiMessages = a.path && a.path.indexOf("api-messages") !== -1;
            return a.cdnUrl
                ? a.cdnUrl
                : isApiMessages
                ? `https://static.supsis.live/${a.path}`
                : `https://static.supsis.live/${a.path}${a.id}.${a.ext}`;
        },
        clicked() {
            console.info("clicked");
            this.fullscreenMode = this.$refs?.imageViewer?.$viewer?.isShown || false;
        },
    },
    created() {
        this.timerId = setInterval(() => {
            console.info("setWindowSize this.$refs.imageViewer", this.$refs.imageViewer);
            this.fullscreenMode = this.$refs?.imageViewer?.$viewer?.isShown || false;
        }, 500);
    },
    beforeDestroy() {
        clearInterval(this.timerId);
    },
    watch: {
        fullscreenMode: {
            handler(isFullscreen) {
                sendCommandToParentWindow("setWindowSize", isFullscreen ? "large" : "normal");
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.cb-pr-icon {
    position: absolute;
}

.cb-img-preview {
    max-width: 100px;
    display: flex;
    align-items: center;
    justify-content: center;

    .cb-pr-icon {
        z-index: 2;
    }
}

#imageMessage {
    position: relative;

    .cb-img-preview:hover {
        cursor: pointer;
        filter: grayscale(100%);
    }

    .image-message-img {
        margin: 18px 6px;
        border-radius: var(--sps-radius-sm);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/V2/popup-chat/messages/ImageMessage.vue